export const WORDS = [
  "ADELA",
  "ADEPT",
  "ADOLF",
  "AFEKT",
  "AFERA",
  "AFGAN",
  "AFIKS",
  "AGAPA",
  "AGATA",
  "AGAVA",
  "AGENS",
  "AGENT",
  "AGRAM",
  "AGRAR",
  "AGRUM",
  "AJVAR",
  "AKANT",
  "AKORD",
  "AKRIL",
  "AKSON",
  "AKTER",
  "AKTIV",
  "ALARM",
  "ALAST",
  "ALAUN",
  "ALBIN",
  "ALBUM",
  "ALEJA",
  "ALIAS",
  "ALIBI",
  "ALIJA",
  "ALISA",
  "ALKAR",
  "ALKIN",
  "ALOJA",
  "ALOJZ",
  "ALŽIR",
  "AMARO",
  "AMBAR",
  "AMBIS",
  "AMBRA",
  "AMEBA",
  "AMPER",
  "AMPIR",
  "ANEKS",
  "ANICA",
  "ANION",
  "ANITA",
  "ANODA",
  "ANTEJ",
  "ANTON",
  "ANTUN",
  "ANĐEL",
  "ANĐEO",
  "AORTA",
  "APAGE",
  "APEKS",
  "APOEN",
  "APOLO",
  "APRIL",
  "ARARA",
  "ARBUN",
  "AREAL",
  "ARENA",
  "ARGON",
  "ARGUS",
  "ARHIV",
  "ARIEL",
  "ARIJA",
  "AROMA",
  "ARPAD",
  "ARSEN",
  "ARTUR",
  "ASEAN",
  "ASKER",
  "ASKET",
  "ASPIK",
  "ASPRA",
  "ASTAT",
  "ASTEK",
  "ASTMA",
  "ASUAN",
  "ASURA",
  "ATAŠE",
  "ATENA",
  "ATEST",
  "ATILA",
  "ATLAS",
  "ATLET",
  "ATONA",
  "ATREJ",
  "ATRIJ",
  "AUDIO",
  "AUGUR",
  "AUTIĆ",
  "AUTOR",
  "AVANS",
  "AVERS",
  "AVION",
  "AVNOJ",
  "AZIJA",
  "AZOIK",
  "AZOLA",
  "AZTEK",
  "BABAC",
  "BABIĆ",
  "BABUN",
  "BACAČ",
  "BACIL",
  "BADEL",
  "BADEM",
  "BAGER",
  "BAGET",
  "BAGOŠ",
  "BAGRA",
  "BAGUŠ",
  "BAHAT",
  "BAJAM",
  "BAJER",
  "BAJKA",
  "BAJNI",
  "BAJTA",
  "BAKAR",
  "BALAV",
  "BALET",
  "BALON",
  "BALUN",
  "BANAK",
  "BANAT",
  "BANDA",
  "BANJA",
  "BANKA",
  "BANTU",
  "BARAN",
  "BARAŽ",
  "BARBA",
  "BAREL",
  "BAREM",
  "BARIJ",
  "BARIL",
  "BARIT",
  "BARKA",
  "BAROK",
  "BARON",
  "BARUN",
  "BARUT",
  "BASNA",
  "BASRA",
  "BATAK",
  "BATIK",
  "BATIĆ",
  "BAZAR",
  "BAZEN",
  "BAZGA",
  "BAZNI",
  "BAČEN",
  "BAČIĆ",
  "BAČKA",
  "BAČKI",
  "BAČVA",
  "BAŠKA",
  "BAŠČA",
  "BEDAK",
  "BEDEM",
  "BEDRO",
  "BEGEŠ",
  "BEKEŠ",
  "BELAJ",
  "BELJE",
  "BELOT",
  "BENAV",
  "BENIN",
  "BERAČ",
  "BERBA",
  "BERIL",
  "BESAN",
  "BETON",
  "BEZOK",
  "BEZUB",
  "BEĆAR",
  "BEČKI",
  "BIBAV",
  "BIBER",
  "BIDON",
  "BIGOT",
  "BIHAĆ",
  "BIJEG",
  "BIJEL",
  "BIJEN",
  "BIJES",
  "BILIN",
  "BILJE",
  "BINAR",
  "BIPED",
  "BIRAČ",
  "BIRET",
  "BISER",
  "BISMO",
  "BISTA",
  "BITAK",
  "BITKA",
  "BITNI",
  "BIVAK",
  "BIVOL",
  "BIVŠI",
  "BIZAM",
  "BIZON",
  "BIČIĆ",
  "BIČJI",
  "BJAŠE",
  "BJEHU",
  "BJEŠE",
  "BLATO",
  "BLAŽI",
  "BLEND",
  "BLIZU",
  "BLIŽI",
  "BLJAK",
  "BLUNA",
  "BLUZA",
  "BODAC",
  "BODEN",
  "BODEŽ",
  "BODRI",
  "BODUL",
  "BOFOR",
  "BOGAC",
  "BOGAT",
  "BOGME",
  "BOJAN",
  "BOJEN",
  "BOJEV",
  "BOJNA",
  "BOJNI",
  "BOKAL",
  "BOLID",
  "BOLJI",
  "BOLNI",
  "BOLTA",
  "BOMBA",
  "BONUS",
  "BORAC",
  "BORAK",
  "BORBA",
  "BORDO",
  "BOREJ",
  "BORIK",
  "BORIS",
  "BORIĆ",
  "BORJE",
  "BORNA",
  "BORNI",
  "BORŠČ",
  "BOSNA",
  "BOSTI",
  "BOTEL",
  "BOZON",
  "BOĆAR",
  "BOČAT",
  "BOČNI",
  "BOŽIĆ",
  "BOŽJI",
  "BOŽUR",
  "BRADA",
  "BRANA",
  "BRATI",
  "BRAVA",
  "BRAĆA",
  "BREME",
  "BREZA",
  "BREĐI",
  "BRICA",
  "BRICO",
  "BRIDŽ",
  "BRIGA",
  "BRIOŠ",
  "BRKAT",
  "BRLJA",
  "BRLOG",
  "BRNJA",
  "BRONH",
  "BRTVA",
  "BRUKA",
  "BRUTO",
  "BRVNO",
  "BRZAC",
  "BRZAK",
  "BRČIĆ",
  "BUDAK",
  "BUDEM",
  "BUDEŠ",
  "BUDIM",
  "BUDNI",
  "BUDVA",
  "BUGAR",
  "BUHAČ",
  "BUJAD",
  "BUJNI",
  "BUJON",
  "BUKAČ",
  "BUKET",
  "BUKOV",
  "BUKVA",
  "BUNAR",
  "BUNDA",
  "BUNJA",
  "BURAG",
  "BUREK",
  "BURIN",
  "BURMA",
  "BURNI",
  "BURSA",
  "BURZA",
  "BUSEN",
  "BUTAN",
  "BUTIK",
  "BUTNI",
  "BUZET",
  "BUČJE",
  "BUČNI",
  "BUĐEN",
  "BUŠAN",
  "BUŠAČ",
  "BUŠEL",
  "BUŠEN",
  "C-DUR",
  "CAKLO",
  "CAREV",
  "CARIĆ",
  "CAZIN",
  "CEDAR",
  "CEFTA",
  "CEKER",
  "CEKIN",
  "CEKUM",
  "CELER",
  "CELJE",
  "CENER",
  "CEPIN",
  "CEREK",
  "CERIJ",
  "CERJE",
  "CESAR",
  "CESTA",
  "CEZAR",
  "CEZIJ",
  "CIBET",
  "CIFRA",
  "CIGAN",
  "CIGIN",
  "CIGLA",
  "CIJAN",
  "CIJEL",
  "CIJEP",
  "CIJEV",
  "CIJEĐ",
  "CIJUK",
  "CIKLA",
  "CIKOT",
  "CILIK",
  "CIMER",
  "CIMET",
  "CINIK",
  "CIPAL",
  "CIPAR",
  "CIPLI",
  "CIRUS",
  "CISTA",
  "CITAT",
  "CITRA",
  "CIVIL",
  "CRKVA",
  "CRNAC",
  "CRNJI",
  "CRNKA",
  "CRPAO",
  "CRPEM",
  "CRPEŠ",
  "CRPKA",
  "CRPLA",
  "CRPNI",
  "CRTAČ",
  "CRTEŽ",
  "CRTIĆ",
  "CRVAK",
  "CRVEN",
  "CRVIĆ",
  "CUNJA",
  "CURAK",
  "D-MOL",
  "DABAR",
  "DADEM",
  "DADEŠ",
  "DADNE",
  "DADOH",
  "DAKLE",
  "DALEK",
  "DALJI",
  "DAMIR",
  "DANAC",
  "DANAK",
  "DANAS",
  "DANJI",
  "DANTE",
  "DARAK",
  "DARIO",
  "DASKA",
  "DATIV",
  "DATUM",
  "DAVAČ",
  "DAVEŽ",
  "DAVID",
  "DAVNI",
  "DAVOR",
  "DAŠAK",
  "DAŠTO",
  "DAŠĆE",
  "DAŠĆI",
  "DEBEO",
  "DEBIL",
  "DEBLO",
  "DEDAL",
  "DEDIĆ",
  "DEIST",
  "DEKAN",
  "DEKOR",
  "DELFI",
  "DELTA",
  "DEMON",
  "DENAR",
  "DENDI",
  "DENGA",
  "DERAČ",
  "DERBI",
  "DERLE",
  "DESET",
  "DESNI",
  "DEVET",
  "DEZEN",
  "DEČKO",
  "DILER",
  "DIMNI",
  "DINAR",
  "DINGO",
  "DINJA",
  "DINKA",
  "DINKO",
  "DIOBA",
  "DIODA",
  "DIONA",
  "DIONI",
  "DIPOL",
  "DISCO",
  "DISKO",
  "DIVAN",
  "DIVIT",
  "DIVNI",
  "DIZAČ",
  "DIZEL",
  "DIČNI",
  "DIŠNI",
  "DJECA",
  "DJELO",
  "DJEVA",
  "DLAKA",
  "DNIMA",
  "DOBIT",
  "DOBNI",
  "DOBRI",
  "DOBRO",
  "DODIR",
  "DOGMA",
  "DOJAM",
  "DOJEN",
  "DOJKA",
  "DOKAD",
  "DOKAZ",
  "DOKLE",
  "DOKON",
  "DOKUD",
  "DOKUP",
  "DOLAC",
  "DOLAR",
  "DOLET",
  "DOLJE",
  "DOMAK",
  "DOMAR",
  "DOMET",
  "DONDE",
  "DONJI",
  "DONOS",
  "DOPIS",
  "DOSAD",
  "DOSEG",
  "DOSJE",
  "DOSTA",
  "DOTAD",
  "DOTLE",
  "DOTOK",
  "DOVDE",
  "DOVOD",
  "DOVOZ",
  "DOZIV",
  "DOČEK",
  "DOČIM",
  "DOŠLI",
  "DRAGA",
  "DRAMA",
  "DRAVA",
  "DRAČA",
  "DRAŽI",
  "DREKA",
  "DRMEŠ",
  "DRNIŠ",
  "DROGA",
  "DROZD",
  "DRSKI",
  "DRUGI",
  "DRUID",
  "DRVAR",
  "DRVCE",
  "DRVEN",
  "DRVNI",
  "DRZAK",
  "DRŠKA",
  "DRŠĆE",
  "DRŠĆI",
  "DRŠĆU",
  "DRŽAK",
  "DRŽAČ",
  "DUBOK",
  "DUGME",
  "DUHAN",
  "DUHAČ",
  "DUKAT",
  "DULJI",
  "DUNAV",
  "DUNJA",
  "DUPIN",
  "DUPKE",
  "DUPLI",
  "DUĆAN",
  "DUŠAK",
  "DUŠAN",
  "DUŠIK",
  "DUŠNI",
  "DUŽNI",
  "DVAJU",
  "DVAMA",
  "DVB-T",
  "DVERI",
  "DVICA",
  "DVIJE",
  "DVIJU",
  "DVOGA",
  "DVOJI",
  "DVOMA",
  "DVORI",
  "DŽABE",
  "DŽUDO",
  "EDIKT",
  "EDITA",
  "EFEKT",
  "EGIDA",
  "EGZIL",
  "EKCEM",
  "EKIPA",
  "EKRAN",
  "EKSON",
  "ELISA",
  "ELITA",
  "EMAJL",
  "EMINA",
  "ENDEM",
  "ENEJA",
  "ENVER",
  "ENZIM",
  "EPARH",
  "EPIKA",
  "EPOHA",
  "ERATO",
  "ERBIJ",
  "ERDUT",
  "ERVIN",
  "ESHIL",
  "ESKIM",
  "ESTER",
  "ESTET",
  "ETAPA",
  "ETAŽA",
  "ETIDA",
  "ETIKA",
  "ETNIK",
  "ETNOS",
  "EUGEN",
  "EUNUH",
  "EXCEL",
  "FAGOT",
  "FAKIN",
  "FAKIR",
  "FALUS",
  "FARBA",
  "FARMA",
  "FARSA",
  "FARSI",
  "FATUM",
  "FAUST",
  "FAZAN",
  "FAZNI",
  "FAZON",
  "FEDER",
  "FENOL",
  "FERDO",
  "FETIŠ",
  "FETUS",
  "FETVA",
  "FEŠTA",
  "FIDŽI",
  "FIJUK",
  "FIKUS",
  "FILEK",
  "FILET",
  "FILIP",
  "FILIR",
  "FINAC",
  "FINIŠ",
  "FINTA",
  "FIRER",
  "FIRMA",
  "FIĆUK",
  "FJORD",
  "FLAŠA",
  "FLEKA",
  "FLERT",
  "FLOEM",
  "FLORA",
  "FLOTA",
  "FLUID",
  "FLUKS",
  "FLUOR",
  "FOAJE",
  "FOBOS",
  "FOKUS",
  "FONDI",
  "FONEM",
  "FORMA",
  "FORTE",
  "FORUM",
  "FOSIL",
  "FOTON",
  "FRAPE",
  "FRAZA",
  "FREND",
  "FREON",
  "FREUD",
  "FRONT",
  "FRULA",
  "FUNTA",
  "FUTUR",
  "GACKA",
  "GADNI",
  "GAJBA",
  "GAJDE",
  "GAJEN",
  "GALEB",
  "GALGE",
  "GALIJ",
  "GALON",
  "GALOP",
  "GAMAD",
  "GARAV",
  "GARDA",
  "GAREŽ",
  "GASIV",
  "GATKA",
  "GAUSS",
  "GAUČO",
  "GAVAN",
  "GAVEZ",
  "GAVUN",
  "GAZDA",
  "GAŠEN",
  "GAŽEN",
  "GEGAV",
  "GEJŠA",
  "GELER",
  "GENIJ",
  "GENOM",
  "GEPEK",
  "GERMA",
  "GESLO",
  "GESTA",
  "GIBAK",
  "GIBON",
  "GILDA",
  "GIPKI",
  "GIZDA",
  "GLANC",
  "GLAVA",
  "GLAĐU",
  "GLEDE",
  "GLINA",
  "GLOBA",
  "GLOSA",
  "GLUMA",
  "GLUON",
  "GLUŠI",
  "GNJEV",
  "GNJIL",
  "GNJUS",
  "GNOZA",
  "GOJEN",
  "GOJNI",
  "GOLAĆ",
  "GOLEM",
  "GOLET",
  "GOLJA",
  "GOLUB",
  "GONIČ",
  "GORAK",
  "GORAN",
  "GORIV",
  "GORJE",
  "GORKI",
  "GORČI",
  "GOSPA",
  "GOTOV",
  "GOVNO",
  "GOVOR",
  "GOZBA",
  "GOŠĆA",
  "GRABA",
  "GRAJA",
  "GRANA",
  "GRAĐA",
  "GRBAV",
  "GRDNI",
  "GREDA",
  "GREJP",
  "GRETA",
  "GRGEČ",
  "GRGUR",
  "GRIPA",
  "GRIVA",
  "GRIŽA",
  "GRLAT",
  "GRLCE",
  "GRLEN",
  "GRLIĆ",
  "GRMAK",
  "GRMAŠ",
  "GRMIĆ",
  "GROGI",
  "GROZA",
  "GROZD",
  "GRUDA",
  "GRUNT",
  "GRUPA",
  "GRČEN",
  "GRČKI",
  "GUBAC",
  "GUBAV",
  "GUBER",
  "GUDAČ",
  "GUGUT",
  "GULAG",
  "GULAŠ",
  "GUMEN",
  "GUMNO",
  "GUNJA",
  "GURAV",
  "GURAČ",
  "GURKA",
  "GUSAK",
  "GUSAN",
  "GUSAR",
  "GUSKA",
  "GUSLE",
  "GUTAČ",
  "GUŠAV",
  "GUŠEN",
  "GUŠĆI",
  "GUŠČE",
  "GUŽVA",
  "GVERC",
  "GVIRC",
  "GVOZD",
  "GĐICA",
  "HABIT",
  "HAHAR",
  "HAIKU",
  "HAITI",
  "HAJDA",
  "HAJDE",
  "HAJKA",
  "HAJMO",
  "HAJTE",
  "HAKER",
  "HALAV",
  "HALON",
  "HALVA",
  "HAMAM",
  "HARAČ",
  "HAREM",
  "HARFA",
  "HASAN",
  "HASID",
  "HASIJ",
  "HAUBA",
  "HAŠIŠ",
  "HAŠKI",
  "HDSSB",
  "HELIJ",
  "HEROD",
  "HEROJ",
  "HETIT",
  "HIDRA",
  "HIHOT",
  "HIMBA",
  "HIMEN",
  "HIMNA",
  "HINDI",
  "HIPER",
  "HIPIK",
  "HITAC",
  "HITIN",
  "HITNI",
  "HITRI",
  "HLAČE",
  "HMELJ",
  "HODAČ",
  "HODŽA",
  "HOKEJ",
  "HOMER",
  "HOMIĆ",
  "HONDA",
  "HORDA",
  "HOROR",
  "HORUS",
  "HOTEL",
  "HOĆEŠ",
  "HOĐAH",
  "HRANA",
  "HRAST",
  "HRBAT",
  "HRPTA",
  "HRPTE",
  "HRPTI",
  "HRPTU",
  "HRUŠT",
  "HRVAT",
  "HRVAČ",
  "HRČAK",
  "HRĐAV",
  "HTJET",
  "HULJA",
  "HUMAK",
  "HUMAN",
  "HUMOR",
  "HUMUS",
  "HUNTA",
  "HUSAR",
  "HUČNI",
  "HVALA",
  "IDEAL",
  "IDEJA",
  "IDILA",
  "IDIOM",
  "IDIOT",
  "IDUĆI",
  "IGALO",
  "IGDJE",
  "IGLEN",
  "IGLUN",
  "IGRAČ",
  "IKADA",
  "IKAKO",
  "IKAMO",
  "IKOGA",
  "IKOJI",
  "IKOME",
  "IKOMU",
  "IKONA",
  "ILICA",
  "ILIJA",
  "ILOVA",
  "IMADE",
  "IMATI",
  "IMELA",
  "IMIDŽ",
  "INAČE",
  "INDIJ",
  "INDRA",
  "INDUS",
  "INGOT",
  "INOČA",
  "INPUT",
  "INĆUN",
  "IRSKA",
  "IRSKI",
  "IRVAS",
  "ISHOD",
  "ISKAN",
  "ISKAZ",
  "ISKON",
  "ISKOP",
  "ISKRA",
  "ISLAM",
  "ISPAD",
  "ISPIS",
  "ISPIT",
  "ISPOD",
  "ISPUH",
  "ISTEK",
  "ISTOK",
  "ISTRA",
  "ISTRT",
  "ISTUP",
  "ISUTI",
  "ITRIJ",
  "IVICA",
  "IVONA",
  "IZAĆI",
  "IZBOJ",
  "IZBOR",
  "IZDAH",
  "IZGON",
  "IZIDA",
  "IZIĆI",
  "IZLAZ",
  "IZLET",
  "IZLOG",
  "IZLOV",
  "IZMAK",
  "IZMET",
  "IZNAD",
  "IZNOS",
  "IZRAZ",
  "IZREZ",
  "IZROD",
  "IZUTI",
  "IZVAN",
  "IZVID",
  "IZVOD",
  "IZVOR",
  "IZVOZ",
  "IČEGA",
  "IČEMU",
  "IČIJI",
  "IĐAHU",
  "IĐAŠE",
  "IŽETI",
  "JADIĆ",
  "JADNI",
  "JAGMA",
  "JAHAČ",
  "JAHTA",
  "JAJAR",
  "JAJCE",
  "JAJNI",
  "JAKNA",
  "JAKOB",
  "JAKOV",
  "JALNI",
  "JALOV",
  "JALTA",
  "JAMAC",
  "JAMNI",
  "JANEZ",
  "JANJA",
  "JANJE",
  "JANKO",
  "JAPAN",
  "JAPOD",
  "JARAC",
  "JARAK",
  "JARAM",
  "JARAN",
  "JARDI",
  "JARIĆ",
  "JARKI",
  "JARUN",
  "JASEN",
  "JASLE",
  "JASNI",
  "JATAK",
  "JAVNI",
  "JAVOR",
  "JAŠEN",
  "JEBAČ",
  "JEBEN",
  "JECAJ",
  "JECAV",
  "JEDAK",
  "JEDAN",
  "JEDEN",
  "JEDRI",
  "JEDRO",
  "JEDVA",
  "JELEK",
  "JELEN",
  "JELKA",
  "JELOV",
  "JEMEN",
  "JENKI",
  "JESAM",
  "JESEN",
  "JESMO",
  "JESTE",
  "JESTI",
  "JETKI",
  "JETRA",
  "JEZDA",
  "JEZIK",
  "JEZIV",
  "JEČAM",
  "JEŠUA",
  "JEŽIĆ",
  "JIDIŠ",
  "JODID",
  "JODNI",
  "JOINT",
  "JOSIP",
  "JOŠUA",
  "JULIA",
  "JULIJ",
  "JUNAC",
  "JUNAK",
  "JURAJ",
  "JUREN",
  "JURIŠ",
  "JURTA",
  "JUTAN",
  "JUTEN",
  "JUTRO",
  "JUČER",
  "JUŠNI",
  "JUŽNI",
  "KABAO",
  "KABEL",
  "KADAR",
  "KADET",
  "KADLI",
  "KADRI",
  "KAFIĆ",
  "KAFKA",
  "KAGAN",
  "KAIRO",
  "KAJAK",
  "KAJDA",
  "KAJLA",
  "KAKAO",
  "KAKAV",
  "KAKVI",
  "KALAJ",
  "KALEB",
  "KALEM",
  "KALEŽ",
  "KALFA",
  "KALIF",
  "KALIJ",
  "KALUP",
  "KAMEN",
  "KAMIN",
  "KAMIŠ",
  "KAMOV",
  "KANAL",
  "KANAT",
  "KANDA",
  "KANON",
  "KANTA",
  "KAPAK",
  "KAPAR",
  "KAPUT",
  "KARAT",
  "KARGO",
  "KARLA",
  "KARMA",
  "KARTA",
  "KASAČ",
  "KASNI",
  "KASTA",
  "KATAR",
  "KATNI",
  "KATON",
  "KATUN",
  "KAVEZ",
  "KAVGA",
  "KAZAN",
  "KAZNA",
  "KAĆUN",
  "KAČIĆ",
  "KAĐEN",
  "KEFIR",
  "KEGLA",
  "KEMAL",
  "KEOPS",
  "KEPEC",
  "KESON",
  "KEČAP",
  "KEČKA",
  "KIBIC",
  "KIBLA",
  "KICOŠ",
  "KIFLA",
  "KIJEV",
  "KIKOT",
  "KILAV",
  "KINEZ",
  "KININ",
  "KIOSK",
  "KIPAR",
  "KIPER",
  "KIPIĆ",
  "KISEO",
  "KISIK",
  "KIVNI",
  "KIĆEN",
  "KIČMA",
  "KIŠNI",
  "KLADA",
  "KLAPA",
  "KLARA",
  "KLASA",
  "KLATI",
  "KLAUN",
  "KLETI",
  "KLEČE",
  "KLICA",
  "KLIKA",
  "KLIMA",
  "KLINČ",
  "KLIŠE",
  "KLJUN",
  "KLJUČ",
  "KLOPA",
  "KLUPA",
  "KNEŽE",
  "KOALA",
  "KOBAC",
  "KOBNI",
  "KOBRA",
  "KOCKA",
  "KODNI",
  "KODON",
  "KOFER",
  "KOJOT",
  "KOKOS",
  "KOKOT",
  "KOKOŠ",
  "KOLAC",
  "KOLAN",
  "KOLAR",
  "KOLAČ",
  "KOLAŽ",
  "KOLET",
  "KOLJA",
  "KOLJE",
  "KOLJI",
  "KOLNI",
  "KOLOR",
  "KOLOS",
  "KOLUT",
  "KOMAD",
  "KOMBI",
  "KOMET",
  "KOMEŠ",
  "KOMIN",
  "KONAC",
  "KONAK",
  "KONGO",
  "KONOP",
  "KONTO",
  "KONUS",
  "KOPAR",
  "KOPAČ",
  "KOPNO",
  "KOPUN",
  "KOPČA",
  "KORAK",
  "KORAL",
  "KOREN",
  "KOROV",
  "KORPA",
  "KORZO",
  "KOSAC",
  "KOSAT",
  "KOSAČ",
  "KOSIR",
  "KOSNI",
  "KOTAC",
  "KOTAO",
  "KOTAR",
  "KOTAČ",
  "KOTOR",
  "KOTUR",
  "KOTVA",
  "KOVAČ",
  "KOVIT",
  "KOZAK",
  "KOZAR",
  "KOZER",
  "KOZJI",
  "KOZLE",
  "KOĆAR",
  "KOČEN",
  "KOČNI",
  "KOŠEN",
  "KOŠER",
  "KOŠIĆ",
  "KOŽAR",
  "KOŽNI",
  "KOŽUH",
  "KOŽUN",
  "KRABA",
  "KRALJ",
  "KRAMA",
  "KRAMP",
  "KRANJ",
  "KRAUL",
  "KRAVA",
  "KRAĆI",
  "KRAĐA",
  "KRCAT",
  "KREDA",
  "KREMA",
  "KREOL",
  "KRETA",
  "KRHKI",
  "KRILO",
  "KRIST",
  "KRITI",
  "KRIZA",
  "KRIŽA",
  "KRMAK",
  "KRMEN",
  "KRMNI",
  "KRMČE",
  "KRNJI",
  "KROKI",
  "KROZA",
  "KROŠE",
  "KRPAR",
  "KRPEN",
  "KRPEŽ",
  "KRSNI",
  "KRUNA",
  "KRUĆI",
  "KRVAV",
  "KRVNI",
  "KRZNO",
  "KRČAG",
  "KRČEN",
  "KRČKI",
  "KRČMA",
  "KRŠEN",
  "KRŠNI",
  "KUBIK",
  "KUBNI",
  "KUBUS",
  "KUCAJ",
  "KUCAČ",
  "KUFER",
  "KUGLA",
  "KUHAR",
  "KUKAC",
  "KULAK",
  "KULEN",
  "KULJA",
  "KULUK",
  "KUMIN",
  "KUMIR",
  "KUMIS",
  "KUMČE",
  "KUNIĆ",
  "KUPAC",
  "KUPAN",
  "KUPAČ",
  "KUPKA",
  "KUPON",
  "KUPUS",
  "KURAC",
  "KURAN",
  "KUREN",
  "KURIJ",
  "KURIR",
  "KURJI",
  "KURVA",
  "KUSAV",
  "KUTAK",
  "KUTIĆ",
  "KUTNI",
  "KUĆNI",
  "KUČKA",
  "KUĐEN",
  "KUŠAČ",
  "KUŽNI",
  "KVAKA",
  "KVANT",
  "KVARC",
  "KVARK",
  "KVART",
  "KVAZI",
  "KVIRC",
  "KVOTA",
  "KVRGA",
  "LABAV",
  "LABIN",
  "LABUD",
  "LAFET",
  "LAGER",
  "LAGUM",
  "LAGVA",
  "LAHOR",
  "LAJAV",
  "LAKAJ",
  "LAKAT",
  "LAKEJ",
  "LAKOM",
  "LAKŠI",
  "LAMPA",
  "LANAC",
  "LANEN",
  "LANUT",
  "LAPIS",
  "LAPOR",
  "LARGA",
  "LARGO",
  "LARMA",
  "LARVA",
  "LASER",
  "LASJU",
  "LASKA",
  "LASTA",
  "LAUDA",
  "LAURA",
  "LAVEŽ",
  "LAVIĆ",
  "LAVOR",
  "LAZAR",
  "LAĐAR",
  "LAŽAC",
  "LAŽNI",
  "LAŽOV",
  "LEDEN",
  "LEGAT",
  "LEGLO",
  "LEJLA",
  "LELEK",
  "LEMEŠ",
  "LEMUR",
  "LENTA",
  "LEPET",
  "LEPRA",
  "LETAK",
  "LETAČ",
  "LETNI",
  "LETVA",
  "LEĐEN",
  "LEĐNI",
  "LEŽAJ",
  "LIBAN",
  "LIBAR",
  "LIBOR",
  "LIBRA",
  "LICEJ",
  "LIDER",
  "LIHVA",
  "LIJEK",
  "LIJEN",
  "LIJEP",
  "LIJES",
  "LIJEV",
  "LIKER",
  "LIMAR",
  "LIMEN",
  "LIMES",
  "LIMFA",
  "LIMIT",
  "LIMUN",
  "LIPID",
  "LIPIK",
  "LIPOV",
  "LIRIK",
  "LISAC",
  "LISKA",
  "LISNI",
  "LISTA",
  "LITIJ",
  "LITRA",
  "LITVA",
  "LIVAC",
  "LIVEN",
  "LIZAČ",
  "LIZIN",
  "LIZOL",
  "LIČEN",
  "LIČKI",
  "LIČNI",
  "LIŠAJ",
  "LIŠCE",
  "LIŠEN",
  "LIŠĆE",
  "LJAGA",
  "LJAMA",
  "LJETI",
  "LJETO",
  "LJUBA",
  "LJUDI",
  "LJULJ",
  "LJUĆI",
  "LOGOR",
  "LOGOS",
  "LOJNI",
  "LOKAL",
  "LOKNA",
  "LOKOT",
  "LOKVA",
  "LOMIV",
  "LOMNI",
  "LONAC",
  "LONJA",
  "LOPOV",
  "LOPOČ",
  "LOPTA",
  "LOSOS",
  "LOTOS",
  "LOVAC",
  "LOVAŠ",
  "LOVNI",
  "LOVOR",
  "LOŽAČ",
  "LOŽEN",
  "LOŽIV",
  "LUBIN",
  "LUGAR",
  "LUGER",
  "LUKAV",
  "LUMEN",
  "LUNAR",
  "LUPAN",
  "LUPAR",
  "LUPEŽ",
  "LUTAK",
  "LUTKA",
  "LUČAC",
  "LUČEN",
  "LUČIĆ",
  "LUČKI",
  "LUČNI",
  "LUĐAK",
  "MACAN",
  "MADAM",
  "MADEŽ",
  "MAGLA",
  "MAGMA",
  "MAHER",
  "MAJKA",
  "MAJOR",
  "MAJUR",
  "MAKAC",
  "MAKAR",
  "MAKRO",
  "MALAC",
  "MALEN",
  "MALER",
  "MALJA",
  "MALKO",
  "MALNE",
  "MALTA",
  "MAMAC",
  "MAMUT",
  "MANGA",
  "MANGO",
  "MANIR",
  "MANJI",
  "MANTA",
  "MARIA",
  "MARKA",
  "MARKO",
  "MARNI",
  "MAROD",
  "MAROF",
  "MARTA",
  "MARVA",
  "MARŽA",
  "MASEN",
  "MASER",
  "MASIV",
  "MASKA",
  "MASLO",
  "MASON",
  "MATEJ",
  "MATEO",
  "MATER",
  "MATOŠ",
  "MAZAČ",
  "MAZGA",
  "MAZIV",
  "MAZNI",
  "MAZUT",
  "MAČAK",
  "MAČEK",
  "MAČIĆ",
  "MAČJI",
  "MAČKA",
  "MAČOR",
  "MAĐAR",
  "MAŠNA",
  "MAŠTA",
  "MAŽEN",
  "MEDAR",
  "MEDEN",
  "MEDIJ",
  "MEDNI",
  "MEKAN",
  "MEKET",
  "MEKŠI",
  "MELEM",
  "MELEZ",
  "MELON",
  "MELOS",
  "MEMLA",
  "MENTA",
  "MENZA",
  "MESAR",
  "MESNI",
  "MESTI",
  "METAK",
  "METAL",
  "METAN",
  "METAR",
  "METEN",
  "METEŽ",
  "METIL",
  "METLA",
  "METRO",
  "MEZIJ",
  "MEZON",
  "MEČKA",
  "MEĐAŠ",
  "MIDER",
  "MIJEH",
  "MIKRO",
  "MILAN",
  "MILJA",
  "MILJE",
  "MILOŠ",
  "MINER",
  "MINUS",
  "MIRAZ",
  "MIREN",
  "MIRHA",
  "MIRIS",
  "MIRKO",
  "MIRNI",
  "MIRTA",
  "MIRZA",
  "MISAL",
  "MISAO",
  "MISNI",
  "MITAR",
  "MITRA",
  "MIŠAR",
  "MIŠIĆ",
  "MIŠJI",
  "MIŠKA",
  "MJERA",
  "MLADA",
  "MLADI",
  "MLAKA",
  "MLAĐI",
  "MLECI",
  "MLJET",
  "MNOGI",
  "MNOME",
  "MODEL",
  "MODEM",
  "MODNI",
  "MODRI",
  "MODUL",
  "MODUS",
  "MOGAH",
  "MOGAO",
  "MOGLA",
  "MOGLE",
  "MOGLI",
  "MOGLO",
  "MOGNI",
  "MOGOH",
  "MOGUL",
  "MOGUĆ",
  "MOHAČ",
  "MOHER",
  "MOKRI",
  "MOLBA",
  "MOMAK",
  "MOMČE",
  "MONAH",
  "MOPED",
  "MORAL",
  "MOREN",
  "MOSNI",
  "MOSOR",
  "MOTEL",
  "MOTET",
  "MOTIV",
  "MOTKA",
  "MOTOR",
  "MOZAK",
  "MOZGU",
  "MOĆNI",
  "MOČEN",
  "MOŠUS",
  "MOŽDA",
  "MOŽEŠ",
  "MRAŠE",
  "MRAŽE",
  "MRENA",
  "MREŽA",
  "MRGOD",
  "MRKLI",
  "MRKOV",
  "MRKVA",
  "MRLJA",
  "MRMOR",
  "MRSKI",
  "MRSNI",
  "MRTAV",
  "MRTVI",
  "MRZAK",
  "MRZLI",
  "MRŠAV",
  "MUCAV",
  "MUDRI",
  "MUKLI",
  "MULAC",
  "MULAT",
  "MUNGO",
  "MUNJA",
  "MURAL",
  "MURVA",
  "MUSAV",
  "MUSTI",
  "MUTAV",
  "MUTEŽ",
  "MUTNI",
  "MUZEJ",
  "MUĆAK",
  "MUĆEN",
  "MUĆKA",
  "MUČEN",
  "MUČKI",
  "MUČNI",
  "MUŠKI",
  "MUŽAR",
  "MUŽEN",
  "MUŽIĆ",
  "NABOJ",
  "NABOR",
  "NACRT",
  "NADIR",
  "NADME",
  "NADMU",
  "NADRO",
  "NADRU",
  "NAFTA",
  "NAGAO",
  "NAGIB",
  "NAGLI",
  "NAGON",
  "NAIME",
  "NAIĆI",
  "NAJAM",
  "NAKIT",
  "NAKON",
  "NAKOT",
  "NALAZ",
  "NALET",
  "NALIK",
  "NALIČ",
  "NALOG",
  "NAMAH",
  "NAMAZ",
  "NAMET",
  "NAMOT",
  "NANIO",
  "NANOS",
  "NAOKO",
  "NAPAD",
  "NAPET",
  "NAPIS",
  "NAPOJ",
  "NAPOL",
  "NAPON",
  "NAPOR",
  "NAPUH",
  "NARAV",
  "NAROD",
  "NASAD",
  "NASIP",
  "NASRT",
  "NATRU",
  "NAUKA",
  "NAVOD",
  "NAVOJ",
  "NAVOZ",
  "NAVRH",
  "NAZAD",
  "NAZAL",
  "NAZEB",
  "NAZIV",
  "NAZOR",
  "NAĆVE",
  "NAČAS",
  "NAČET",
  "NAČIN",
  "NAĐEN",
  "NAŠIT",
  "NAŽAO",
  "NEFIN",
  "NEGDA",
  "NEHAJ",
  "NEHAT",
  "NEJAK",
  "NEJAČ",
  "NEKAD",
  "NEKOĆ",
  "NEKUD",
  "NEMAN",
  "NEMAR",
  "NEMIO",
  "NEMIR",
  "NEMOJ",
  "NEMOĆ",
  "NENAD",
  "NEPAL",
  "NEPCE",
  "NEPUN",
  "NERAD",
  "NERED",
  "NESIT",
  "NESTI",
  "NETKO",
  "NETOM",
  "NEVEN",
  "NEVIN",
  "NEĆAK",
  "NEĆEŠ",
  "NEČEG",
  "NEČEM",
  "NEČIM",
  "NEŠTO",
  "NEŽIV",
  "NIJEM",
  "NIKAD",
  "NIKAL",
  "NIKAO",
  "NIKIM",
  "NIKOG",
  "NIKOM",
  "NIKUD",
  "NIMFA",
  "NISAM",
  "NISKA",
  "NISKI",
  "NISMO",
  "NISTE",
  "NITKO",
  "NITNA",
  "NITNI",
  "NIZAK",
  "NIČEG",
  "NIČIM",
  "NIŠAN",
  "NIŠTA",
  "NJEGA",
  "NJEMU",
  "NJIMA",
  "NJIME",
  "NJIVA",
  "NJOKA",
  "NJOME",
  "NOBEL",
  "NOGAR",
  "NOGAT",
  "NOKAT",
  "NOMAD",
  "NORMA",
  "NOSAT",
  "NOSAČ",
  "NOSIV",
  "NOSIĆ",
  "NOSNI",
  "NOTAR",
  "NOTES",
  "NOTNI",
  "NOVAC",
  "NOVAK",
  "NOĆAS",
  "NOĆCA",
  "NOĆNI",
  "NOŠEN",
  "NOŽIĆ",
  "NOŽNI",
  "NUJNI",
  "NULTI",
  "NUĐEN",
  "NUŽDA",
  "NUŽNI",
  "OAPEC",
  "OBAJU",
  "OBALA",
  "OBDAN",
  "OBITI",
  "OBIĆI",
  "OBJED",
  "OBLAK",
  "OBLIK",
  "OBLOG",
  "OBNOĆ",
  "OBOJI",
  "OBOMA",
  "OBRAT",
  "OBRAZ",
  "OBRED",
  "OBRIS",
  "OBROK",
  "OBRUB",
  "OBRUČ",
  "OBRVA",
  "OBUKA",
  "OBUTI",
  "OBUĆA",
  "OBUĆI",
  "OBZIR",
  "OBZOR",
  "OCEAN",
  "OCTEN",
  "ODADE",
  "ODAJA",
  "ODATI",
  "ODBOR",
  "ODEMO",
  "ODETE",
  "ODGOJ",
  "ODJEK",
  "ODJEL",
  "ODMAH",
  "ODMAK",
  "ODMOR",
  "ODNOS",
  "ODOKA",
  "ODORA",
  "ODOŠE",
  "ODRAN",
  "ODRAZ",
  "ODRED",
  "ODROD",
  "ODRON",
  "ODSAD",
  "ODSUT",
  "ODUKA",
  "ODVEĆ",
  "ODVOD",
  "ODVOZ",
  "ODZIV",
  "ODŽAK",
  "OGANJ",
  "OGLAS",
  "OGLAV",
  "OGLED",
  "OHRID",
  "OJAČI",
  "OKANA",
  "OKICE",
  "OKLOP",
  "OKOLO",
  "OKRET",
  "OKRUG",
  "OKSID",
  "OKTAN",
  "OKTET",
  "OKUKA",
  "OKVIR",
  "OLAKI",
  "OLEIN",
  "OLIMP",
  "OLOVO",
  "OLTAR",
  "OLUJA",
  "OMAMA",
  "OMARA",
  "OMAĆI",
  "OMEGA",
  "OMJER",
  "OMLET",
  "OMSKI",
  "ONAKO",
  "ONAMO",
  "ONDJE",
  "ONIKS",
  "ONIME",
  "ONIŽI",
  "ONOMU",
  "ONUDA",
  "ONČAS",
  "OPEKA",
  "OPERA",
  "OPEĆI",
  "OPHOD",
  "OPITI",
  "OPKOP",
  "OPREZ",
  "OPSEG",
  "OPTOK",
  "OPUTA",
  "OPĆEN",
  "OPŠAV",
  "OPŠIT",
  "ORADA",
  "ORATI",
  "ORAĆI",
  "ORDEN",
  "OREOL",
  "OREĆI",
  "ORFEJ",
  "ORGAN",
  "ORION",
  "ORITI",
  "ORKAN",
  "ORLIĆ",
  "ORLOV",
  "ORMAR",
  "ORNAT",
  "ORTAK",
  "ORUĐE",
  "OSAMA",
  "OSEKA",
  "OSICA",
  "OSION",
  "OSJET",
  "OSLIĆ",
  "OSLON",
  "OSLOV",
  "OSMAN",
  "OSMIJ",
  "OSOBA",
  "OSUDA",
  "OSUTI",
  "OSVIT",
  "OSVRT",
  "OTADA",
  "OTALE",
  "OTAMO",
  "OTARE",
  "OTARI",
  "OTARU",
  "OTAVA",
  "OTEPE",
  "OTEPI",
  "OTEPU",
  "OTETI",
  "OTEĆI",
  "OTIĆI",
  "OTKAD",
  "OTKAZ",
  "OTKOS",
  "OTKUD",
  "OTKUP",
  "OTPAD",
  "OTPIS",
  "OTPOR",
  "OTPRT",
  "OTREM",
  "OTRLA",
  "OTROV",
  "OTUDA",
  "OTUĆI",
  "OTVOR",
  "OVAKO",
  "OVAMO",
  "OVDJE",
  "OVEĆI",
  "OVIME",
  "OVITI",
  "OVJES",
  "OVLAŠ",
  "OVNOV",
  "OVOMU",
  "OVRHA",
  "OVUDA",
  "OVČAR",
  "OVČJI",
  "OZDOL",
  "OZIMI",
  "OČALE",
  "OČICA",
  "OČIJU",
  "OČIMA",
  "OŠTRI",
  "OŽEME",
  "OŽEĆI",
  "OŽMEM",
  "PACER",
  "PACKA",
  "PADEŽ",
  "PAGAN",
  "PAJAC",
  "PAJZL",
  "PAKAO",
  "PAKET",
  "PALAC",
  "PALEŽ",
  "PALMA",
  "PAMET",
  "PAMPA",
  "PAMUK",
  "PANDA",
  "PANEL",
  "PAPAK",
  "PAPAR",
  "PAPIR",
  "PAPUK",
  "PARAF",
  "PARBA",
  "PAREN",
  "PARIP",
  "PARIS",
  "PARIZ",
  "PARIĆ",
  "PARNI",
  "PAROH",
  "PASAT",
  "PASAŽ",
  "PASIV",
  "PASJI",
  "PASKA",
  "PASOŠ",
  "PASTA",
  "PASTI",
  "PASUS",
  "PATAK",
  "PATER",
  "PATKA",
  "PATOS",
  "PAUZA",
  "PAVAO",
  "PAVLA",
  "PAVLE",
  "PAVLU",
  "PAZAR",
  "PAZIN",
  "PAZUH",
  "PAĆEN",
  "PAČIĆ",
  "PAČJI",
  "PAŠKI",
  "PAŠTA",
  "PAŠČE",
  "PAŽEN",
  "PECAR",
  "PEDER",
  "PEGAZ",
  "PEGLA",
  "PEHAR",
  "PEKAR",
  "PELIN",
  "PELIR",
  "PELUD",
  "PENAL",
  "PENIS",
  "PEPEO",
  "PERAD",
  "PERAČ",
  "PERCE",
  "PEREC",
  "PERIN",
  "PERIŠ",
  "PERJE",
  "PERLA",
  "PERON",
  "PERUN",
  "PERUT",
  "PESOS",
  "PETAK",
  "PETAR",
  "PETIT",
  "PETNI",
  "PETRA",
  "PEĆAR",
  "PEČAT",
  "PEČEN",
  "PEŠTA",
  "PEŠĆE",
  "PIJAN",
  "PIJUK",
  "PIJUN",
  "PILAR",
  "PILAT",
  "PILAV",
  "PILIĆ",
  "PILON",
  "PILOT",
  "PINKL",
  "PINTA",
  "PIPAC",
  "PIPAK",
  "PIPAV",
  "PIRAN",
  "PIRAT",
  "PIREJ",
  "PIRIT",
  "PISAC",
  "PISAK",
  "PISAR",
  "PISAČ",
  "PISMO",
  "PISTA",
  "PITAČ",
  "PITKI",
  "PITOM",
  "PITON",
  "PIVAR",
  "PIVCE",
  "PIVOT",
  "PIZDA",
  "PIZMA",
  "PIČKA",
  "PIŠTA",
  "PJEGA",
  "PJENA",
  "PLAST",
  "PLATA",
  "PLATO",
  "PLAĆA",
  "PLAŠT",
  "PLAŽA",
  "PLEME",
  "PLEĆA",
  "PLIMA",
  "PLIVA",
  "PLIĆI",
  "PLJAS",
  "PLJUS",
  "PLOHA",
  "PLOČA",
  "PLUTO",
  "PLUĆA",
  "PODIJ",
  "PODLI",
  "PODNI",
  "PODUG",
  "POEMA",
  "POGAN",
  "POGON",
  "POHOD",
  "POJAC",
  "POJAM",
  "POJAS",
  "POJEN",
  "POKAL",
  "POKAZ",
  "POKER",
  "POKOJ",
  "POKOP",
  "POKUS",
  "POLEN",
  "POLET",
  "POLIO",
  "POLIP",
  "POLIS",
  "POLJE",
  "POLKA",
  "POLOG",
  "POMAK",
  "POMET",
  "POMNI",
  "POMOL",
  "POMOR",
  "POMOĆ",
  "POMPA",
  "PONAD",
  "PONIO",
  "PONOR",
  "PONOS",
  "PONOĆ",
  "PONČO",
  "POPAJ",
  "POPIS",
  "POPUT",
  "PORAT",
  "PORAZ",
  "PORED",
  "POREN",
  "POREZ",
  "POREČ",
  "PORIV",
  "PORNO",
  "POROD",
  "POROK",
  "PORTA",
  "PORUB",
  "POSAO",
  "POSIP",
  "POSNI",
  "POSTO",
  "POSVE",
  "POTEZ",
  "POTIH",
  "POTKA",
  "POTOK",
  "POTOM",
  "POTOP",
  "POTRE",
  "POTRT",
  "POUKA",
  "POVEZ",
  "POVIK",
  "POVIT",
  "POVOD",
  "POVOJ",
  "POVRH",
  "POZER",
  "POZIV",
  "POZLI",
  "POZNI",
  "POZOR",
  "POČEK",
  "POČET",
  "POČEV",
  "POŠTA",
  "POŽAR",
  "POŽET",
  "PRASE",
  "PRATI",
  "PRDAC",
  "PRDEŽ",
  "PREKO",
  "PRELO",
  "PREMA",
  "PRESA",
  "PREZL",
  "PREĆI",
  "PREČI",
  "PREĐA",
  "PREŠA",
  "PRGAV",
  "PRHKI",
  "PRHUT",
  "PRIDE",
  "PRIJA",
  "PRIMA",
  "PRINC",
  "PRIOR",
  "PRIĆI",
  "PRIČA",
  "PRIŠT",
  "PRKNO",
  "PRKOS",
  "PRNJA",
  "PROBA",
  "PROJA",
  "PROSO",
  "PROST",
  "PROTA",
  "PROVA",
  "PROZA",
  "PROĆI",
  "PRSAT",
  "PRSNI",
  "PRTEN",
  "PRUGA",
  "PRUĆE",
  "PRVAK",
  "PRČEN",
  "PRŠIĆ",
  "PRŠUT",
  "PRŽEN",
  "PRŽUN",
  "PSETO",
  "PSEĆI",
  "PSIHA",
  "PSINA",
  "PSSST",
  "PSUNJ",
  "PTICA",
  "PTIČE",
  "PUCAČ",
  "PUDER",
  "PUHAČ",
  "PUKLI",
  "PULEN",
  "PULPA",
  "PUMPA",
  "PUNAC",
  "PUNKT",
  "PUNĐA",
  "PUPAK",
  "PUPAV",
  "PURAN",
  "PURIN",
  "PUSTA",
  "PUTAR",
  "PUTEN",
  "PUTIĆ",
  "PUTNI",
  "PUZAV",
  "PUĆEN",
  "PUČAN",
  "PUŠAČ",
  "PUŠKA",
  "PUŽNI",
  "PČELA",
  "RABAT",
  "RABIN",
  "RABOŠ",
  "RADAR",
  "RADIJ",
  "RADIN",
  "RADIĆ",
  "RADNI",
  "RADON",
  "RADŽA",
  "RAFAL",
  "RAGBI",
  "RAHLI",
  "RAJNA",
  "RAJON",
  "RAKAR",
  "RAKUN",
  "RALJA",
  "RAMPA",
  "RANAC",
  "RANAR",
  "RANKA",
  "RAPIR",
  "RAROG",
  "RASAD",
  "RASAP",
  "RASNI",
  "RASOL",
  "RASTI",
  "RATAN",
  "RATAR",
  "RATNI",
  "RAVEL",
  "RAVNI",
  "RAZNI",
  "RAZOR",
  "RAZUM",
  "RAČIĆ",
  "RAČJI",
  "RAČUN",
  "RAČVA",
  "RAĐEN",
  "RAŠKI",
  "RAŠPA",
  "RAŽEN",
  "RBINA",
  "REBRO",
  "REBUS",
  "REDAK",
  "REDAR",
  "REDNI",
  "REDOV",
  "REFUL",
  "REGAL",
  "REGOČ",
  "REKET",
  "REKUĆ",
  "RELEJ",
  "REMEN",
  "RENIJ",
  "RENTA",
  "REPAT",
  "REPER",
  "REPIĆ",
  "REPNI",
  "RERNA",
  "RESKI",
  "RESOR",
  "RETOR",
  "REUMA",
  "REVER",
  "REVIR",
  "REVNI",
  "REZAK",
  "REZAČ",
  "REZON",
  "REČEN",
  "REĐEN",
  "REŽIM",
  "RIBAR",
  "RIBEŽ",
  "RIBIZ",
  "RIBIČ",
  "RIJEČ",
  "RIKŠA",
  "RILCE",
  "RILKE",
  "RISAČ",
  "RITAM",
  "RITER",
  "RIVAL",
  "RIVEN",
  "RIZIK",
  "RIZOM",
  "RIĐAN",
  "RJEĐI",
  "ROBNI",
  "ROBOT",
  "RODEO",
  "RODIJ",
  "RODNI",
  "RODOS",
  "ROGAT",
  "ROGAČ",
  "ROGOZ",
  "ROHAV",
  "ROJEN",
  "ROJTA",
  "ROKER",
  "ROLNA",
  "ROMAN",
  "ROMEO",
  "ROMON",
  "ROMOR",
  "RONAC",
  "ROSNI",
  "ROTOR",
  "ROVAC",
  "ROVAČ",
  "ROVAŠ",
  "ROVKA",
  "ROZGA",
  "ROČNI",
  "ROĐAK",
  "ROĐEN",
  "ROŠEN",
  "RUBAC",
  "RUBIN",
  "RUBNI",
  "RUDAR",
  "RUDNI",
  "RUGAČ",
  "RUGLO",
  "RUINA",
  "RUJNI",
  "RUKAV",
  "RULET",
  "RULJA",
  "RUMEN",
  "RUNDA",
  "RUSKI",
  "RUTAV",
  "RUČAK",
  "RUČKA",
  "RUČNI",
  "RUĐER",
  "RUŠEN",
  "RUŽEN",
  "RUŽNI",
  "RZATI",
  "SABAT",
  "SABOR",
  "SADNI",
  "SADRA",
  "SAFIR",
  "SAJAM",
  "SAJLA",
  "SAKAT",
  "SALAŠ",
  "SALDO",
  "SALON",
  "SALPA",
  "SALSA",
  "SALTO",
  "SALVA",
  "SAMAC",
  "SAMAR",
  "SAMBA",
  "SAMIT",
  "SAMOA",
  "SAMRT",
  "SAMUR",
  "SANAK",
  "SANJA",
  "SANJE",
  "SANTA",
  "SAPET",
  "SAPUN",
  "SARAJ",
  "SARIN",
  "SARMA",
  "SASKI",
  "SATAN",
  "SATEN",
  "SATIR",
  "SATIĆ",
  "SATNI",
  "SATRH",
  "SATRO",
  "SATRT",
  "SAUNA",
  "SAVAO",
  "SAVEZ",
  "SAZIV",
  "SAČMA",
  "SAĐEN",
  "SAŽET",
  "SCENA",
  "SEBAR",
  "SEBRA",
  "SEDAM",
  "SEDEF",
  "SEDLO",
  "SEDMI",
  "SEKSI",
  "SEKTA",
  "SELAM",
  "SELCE",
  "SELCI",
  "SELEN",
  "SELIM",
  "SEMIT",
  "SENAT",
  "SEOBA",
  "SEOCE",
  "SEPSA",
  "SERUM",
  "SERVO",
  "SETER",
  "SEZAM",
  "SFERA",
  "SHEMA",
  "SIBIR",
  "SIDRO",
  "SIFON",
  "SIGET",
  "SIJAM",
  "SIJAČ",
  "SIJED",
  "SIJEV",
  "SILAZ",
  "SILNI",
  "SILOS",
  "SINAJ",
  "SINCI",
  "SINGL",
  "SINJI",
  "SINKO",
  "SINKU",
  "SINOĆ",
  "SINUS",
  "SINČE",
  "SIPKI",
  "SIRAC",
  "SIRAK",
  "SIRAČ",
  "SIREN",
  "SIROT",
  "SIROV",
  "SIRUP",
  "SISAK",
  "SISAR",
  "SISAT",
  "SITAR",
  "SITNI",
  "SIVAC",
  "SIĆAN",
  "SIŠLI",
  "SJATI",
  "SJEME",
  "SJENA",
  "SJETA",
  "SJEĆI",
  "SJEČA",
  "SKALA",
  "SKALP",
  "SKAMP",
  "SKAUT",
  "SKELA",
  "SKICA",
  "SKIDE",
  "SKIJA",
  "SKLAD",
  "SKLEK",
  "SKLON",
  "SKLOP",
  "SKOBA",
  "SKRAD",
  "SKRIT",
  "SKROZ",
  "SKUTA",
  "SKUŠA",
  "SLAJD",
  "SLAMA",
  "SLAST",
  "SLATI",
  "SLAVA",
  "SLAĐI",
  "SLENG",
  "SLEĆI",
  "SLIKA",
  "SLINA",
  "SLITI",
  "SLJEZ",
  "SLOGA",
  "SLOVO",
  "SLUGA",
  "SLUNJ",
  "SMAĆI",
  "SMEĆE",
  "SMEĐI",
  "SMION",
  "SMJER",
  "SMOCI",
  "SMOJE",
  "SMOJI",
  "SMOJU",
  "SMOLA",
  "SMOĆI",
  "SMRAD",
  "SMRĆU",
  "SMRČA",
  "SNAGA",
  "SNAHA",
  "SNAĆI",
  "SNOVI",
  "SOBAR",
  "SOBNI",
  "SODAR",
  "SOKAK",
  "SOKNA",
  "SOKOL",
  "SOLIN",
  "SOLJU",
  "SOLNI",
  "SOLUN",
  "SOMIĆ",
  "SOMUN",
  "SONAR",
  "SONDA",
  "SONET",
  "SORTA",
  "SOČNI",
  "SOŠNI",
  "SPALI",
  "SPEĆI",
  "SPJEV",
  "SPLAV",
  "SPLET",
  "SPLIT",
  "SPONA",
  "SPORA",
  "SPORT",
  "SPRAM",
  "SPREJ",
  "SPRUD",
  "SPRVA",
  "SPUST",
  "SRATI",
  "SRBIN",
  "SRDIT",
  "SRDIŠ",
  "SREĆA",
  "SRČAN",
  "STADE",
  "STADO",
  "STAJA",
  "START",
  "STATI",
  "STAZA",
  "STEGA",
  "STELA",
  "STEON",
  "STEPA",
  "STERA",
  "STEVO",
  "STEĆI",
  "STIPO",
  "STIĆI",
  "STJEG",
  "STOIK",
  "STOKA",
  "STOPA",
  "STOTI",
  "STRAH",
  "STRAN",
  "STRES",
  "STRIC",
  "STRIP",
  "STRKA",
  "STROG",
  "STROJ",
  "STROP",
  "STRUG",
  "STRUK",
  "STUBA",
  "STVAR",
  "STVOR",
  "SUADA",
  "SUDAC",
  "SUDAN",
  "SUDAR",
  "SUDBA",
  "SUKNO",
  "SUKOB",
  "SUKUS",
  "SULUD",
  "SUMER",
  "SUNCE",
  "SUNIT",
  "SUPEK",
  "SUPER",
  "SUPKA",
  "SURKA",
  "SURLA",
  "SUROV",
  "SUSHI",
  "SUTLA",
  "SUTON",
  "SUTRA",
  "SUVAG",
  "SUZNI",
  "SUĆUT",
  "SUČEV",
  "SUĐEN",
  "SUŠAC",
  "SUŠAK",
  "SUŠEN",
  "SUŠIV",
  "SUŠNI",
  "SUŠTI",
  "SUŽEN",
  "SVAKI",
  "SVAST",
  "SVAĐA",
  "SVEGA",
  "SVEMU",
  "SVEZA",
  "SVILA",
  "SVIMA",
  "SVIME",
  "SVITA",
  "SVITI",
  "SVJEŽ",
  "SVOMU",
  "SVOTA",
  "SVRAB",
  "SVRHA",
  "SVUDA",
  "SVUĆI",
  "TABAK",
  "TABAN",
  "TABLA",
  "TABOR",
  "TACNA",
  "TADIĆ",
  "TAJAC",
  "TAJEN",
  "TAJGA",
  "TAJNA",
  "TAJNI",
  "TAKSA",
  "TAKSI",
  "TAKVI",
  "TALAC",
  "TALAR",
  "TALIJ",
  "TALIR",
  "TALOG",
  "TALON",
  "TAMIL",
  "TAMNI",
  "TANAC",
  "TANAN",
  "TANGA",
  "TANGO",
  "TANIN",
  "TANJI",
  "TANKI",
  "TAPIR",
  "TARAC",
  "TAREM",
  "TAREŠ",
  "TARNI",
  "TAROK",
  "TAROT",
  "TATAR",
  "TAVAN",
  "TAČKE",
  "TAČKI",
  "TAŽEN",
  "TEGLA",
  "TEKST",
  "TEKUT",
  "TELAC",
  "TELAL",
  "TELIĆ",
  "TELUR",
  "TEMPO",
  "TEMZA",
  "TENDA",
  "TENIS",
  "TENJA",
  "TENOR",
  "TEPAV",
  "TEPEN",
  "TEPIH",
  "TERCA",
  "TEREN",
  "TERET",
  "TERME",
  "TERMO",
  "TEROR",
  "TESAR",
  "TESLA",
  "TETAK",
  "TETIS",
  "TETKA",
  "TEUTA",
  "TEZEJ",
  "TEZGA",
  "TEČAJ",
  "TEČNI",
  "TEŠKI",
  "TEŽAK",
  "THETA",
  "THORA",
  "TIBER",
  "TIBET",
  "TIFUS",
  "TIGAR",
  "TIHAN",
  "TIJEK",
  "TIKOV",
  "TIKVA",
  "TILDA",
  "TIMAR",
  "TIMIN",
  "TIMOR",
  "TINEL",
  "TINTA",
  "TIPKA",
  "TIROL",
  "TISAK",
  "TISNO",
  "TISOV",
  "TITAN",
  "TITOV",
  "TIŠMA",
  "TJEME",
  "TKATI",
  "TKIVO",
  "TLAKA",
  "TMAST",
  "TMICA",
  "TMINA",
  "TOBOM",
  "TOBOŽ",
  "TOKAJ",
  "TOKAR",
  "TOKIO",
  "TOMAC",
  "TOMIĆ",
  "TONER",
  "TONIK",
  "TONUS",
  "TOPAO",
  "TOPAZ",
  "TOPIV",
  "TOPIĆ",
  "TOPLI",
  "TOPOT",
  "TOPUZ",
  "TORBA",
  "TORIJ",
  "TORTA",
  "TORUS",
  "TORZO",
  "TOTAL",
  "TOTEM",
  "TOVAR",
  "TOVNI",
  "TOČAK",
  "TOČEN",
  "TOČKA",
  "TOČNI",
  "TRAKA",
  "TRAKT",
  "TRANS",
  "TRASA",
  "TRAVA",
  "TRBUH",
  "TREMA",
  "TREND",
  "TREĆI",
  "TRGIĆ",
  "TRGLA",
  "TRGLI",
  "TRGLO",
  "TRGOH",
  "TRICA",
  "TRIJA",
  "TRIJU",
  "TRIKO",
  "TRIMA",
  "TRIOM",
  "TRKAČ",
  "TRNAC",
  "TRNAK",
  "TRNJE",
  "TROGA",
  "TROJA",
  "TROJI",
  "TRPKI",
  "TRPNI",
  "TRSAT",
  "TRSJE",
  "TRSKA",
  "TRUBA",
  "TRULI",
  "TRUPA",
  "TRUST",
  "TRVEN",
  "TRZAJ",
  "TRZAV",
  "TRČKA",
  "TRŽEN",
  "TRŽNI",
  "TUBUS",
  "TUCET",
  "TUKAC",
  "TUKAN",
  "TULIJ",
  "TULUM",
  "TUMAČ",
  "TUMOR",
  "TUMUL",
  "TUNEL",
  "TUNIS",
  "TUNJA",
  "TUPAN",
  "TUPAV",
  "TURBE",
  "TURBO",
  "TURCI",
  "TURKE",
  "TUTOR",
  "TUZLA",
  "TUČAK",
  "TUČEN",
  "TUĐIN",
  "TUŽBA",
  "TUŽEN",
  "TUŽNI",
  "TVOGA",
  "TVOJI",
  "TVOME",
  "TVOMU",
  "TVRĐI",
  "UBITI",
  "UBRUS",
  "UBRZO",
  "UDADE",
  "UDAJA",
  "UDALJ",
  "UDATI",
  "UDBAŠ",
  "UDICA",
  "UDJEL",
  "UDOVA",
  "UFATI",
  "UGALJ",
  "UGLAS",
  "UGLAT",
  "UGLED",
  "UGLOM",
  "UGODA",
  "UGRIZ",
  "UHODA",
  "UKLET",
  "UKOSO",
  "UKRAS",
  "UKRIŽ",
  "UKRUG",
  "ULEMA",
  "ULICA",
  "ULITI",
  "ULJAN",
  "ULJAR",
  "ULJEN",
  "ULJEZ",
  "ULJNI",
  "ULKUS",
  "ULOGA",
  "ULTRA",
  "ULUDO",
  "UMALO",
  "UMAĆI",
  "UMITI",
  "UMNIK",
  "UMRLI",
  "UNFPA",
  "UNHCR",
  "UNIJA",
  "UNIĆI",
  "UNSKI",
  "UNUKA",
  "UNUČE",
  "UOČEN",
  "UPALA",
  "UPETI",
  "UPEĆI",
  "UPITI",
  "UPLIV",
  "UPOLA",
  "UPORA",
  "UPUTA",
  "URBAN",
  "UREĆI",
  "URICA",
  "URLIK",
  "UROTA",
  "USANA",
  "USHIT",
  "USIMA",
  "USJEK",
  "USJEV",
  "USKOK",
  "USKRS",
  "USMEN",
  "USNEN",
  "USNIK",
  "USPON",
  "USPUT",
  "USRED",
  "USTAV",
  "USTUK",
  "USUTI",
  "UTAJA",
  "UTEĆI",
  "UTIHA",
  "UTREM",
  "UTRKA",
  "UTRLA",
  "UTRLI",
  "UTUĆI",
  "UVALA",
  "UVELI",
  "UVEČE",
  "UVITI",
  "UVJET",
  "UVUĆI",
  "UZAĆI",
  "UZDAH",
  "UZDUH",
  "UZDUŽ",
  "UZETI",
  "UZGOJ",
  "UZGON",
  "UZICA",
  "UZITI",
  "UZIĆI",
  "UZLAZ",
  "UZLET",
  "UZMAK",
  "UZNIK",
  "UZNIO",
  "UZROK",
  "UZVIK",
  "UČILO",
  "UČITI",
  "UČTIV",
  "UŠARA",
  "UŠESA",
  "UŠICA",
  "UŠITI",
  "UŠTAP",
  "UŠTRB",
  "UŽEĆI",
  "UŽINA",
  "UŽIVO",
  "UŽIŽE",
  "VABAC",
  "VAGAŠ",
  "VAGON",
  "VAJDA",
  "VAJNI",
  "VAKUF",
  "VALIĆ",
  "VALNI",
  "VAPAJ",
  "VAPNO",
  "VARAN",
  "VARAV",
  "VAREN",
  "VARKA",
  "VAROŠ",
  "VATRA",
  "VAZAL",
  "VAZDA",
  "VAĐEN",
  "VAŠAR",
  "VAŽNI",
  "VEDRI",
  "VEGAN",
  "VELIK",
  "VELIM",
  "VELIŠ",
  "VELNA",
  "VELOM",
  "VELUR",
  "VEOMA",
  "VEPAR",
  "VERGL",
  "VESEO",
  "VESLO",
  "VESNA",
  "VESTA",
  "VESTI",
  "VEZAČ",
  "VEZEN",
  "VEZIR",
  "VEZNI",
  "VEZUV",
  "VEČER",
  "VIDAR",
  "VIDEO",
  "VIDIK",
  "VIDJE",
  "VIDNI",
  "VIDRA",
  "VIHOR",
  "VIJAK",
  "VIJEK",
  "VIKAR",
  "VIKAČ",
  "VINAR",
  "VINCE",
  "VINIL",
  "VINKO",
  "VINOV",
  "VIOLA",
  "VIRUS",
  "VISAK",
  "VISKI",
  "VISLA",
  "VISOK",
  "VITAK",
  "VITAO",
  "VITEZ",
  "VITKI",
  "VITLO",
  "VIZIR",
  "VIČNI",
  "VIĐEN",
  "VIŠAK",
  "VIŠKI",
  "VIŠNU",
  "VIŽLA",
  "VIŽLE",
  "VJEKE",
  "VJERA",
  "VJEĐA",
  "VJEŠT",
  "VLADA",
  "VLAGA",
  "VLAJI",
  "VLAST",
  "VODEN",
  "VODIK",
  "VODIČ",
  "VODNI",
  "VOJAK",
  "VOJKO",
  "VOJNA",
  "VOJNI",
  "VOKAL",
  "VOLAN",
  "VOLAR",
  "VOLEJ",
  "VOLGA",
  "VOLIĆ",
  "VOLJA",
  "VOLTA",
  "VOSAK",
  "VOTKA",
  "VOZAR",
  "VOZAČ",
  "VOZNI",
  "VOĆAR",
  "VOĆKA",
  "VOĆNI",
  "VOĐEN",
  "VOŽEN",
  "VRANA",
  "VRATA",
  "VRBAS",
  "VRBIK",
  "VRBOV",
  "VRCAV",
  "VRELI",
  "VRELO",
  "VREVA",
  "VREĆA",
  "VRIJE",
  "VRIJU",
  "VRIMO",
  "VRITE",
  "VRITI",
  "VRLET",
  "VRPCA",
  "VRSNI",
  "VRSTA",
  "VRTAN",
  "VRTIĆ",
  "VRTNI",
  "VRUCI",
  "VRZIN",
  "VRČIĆ",
  "VRŠAK",
  "VRŠEN",
  "VRŠNI",
  "VULVA",
  "VUNEN",
  "VUČAK",
  "VUČEN",
  "VUČIĆ",
  "VUČJI",
  "VUČKO",
  "VUČNI",
  "ZABAT",
  "ZABIT",
  "ZABOK",
  "ZADAH",
  "ZADAK",
  "ZADAN",
  "ZADAR",
  "ZADAT",
  "ZADRT",
  "ZAHOD",
  "ZAJAM",
  "ZAJEB",
  "ZAJEO",
  "ZAKON",
  "ZAKUP",
  "ZALAZ",
  "ZALET",
  "ZALOG",
  "ZALUD",
  "ZAMAH",
  "ZAMAK",
  "ZAMET",
  "ZAMKA",
  "ZAMOR",
  "ZANAT",
  "ZANOS",
  "ZAOVA",
  "ZAPAD",
  "ZAPAH",
  "ZAPET",
  "ZAPIS",
  "ZAPOR",
  "ZAPRU",
  "ZAPUH",
  "ZARAD",
  "ZAREZ",
  "ZARON",
  "ZARUB",
  "ZASAD",
  "ZASUN",
  "ZATIM",
  "ZATON",
  "ZATOR",
  "ZATRT",
  "ZAVOD",
  "ZAVOJ",
  "ZAVOR",
  "ZAVRI",
  "ZAZIV",
  "ZAZOR",
  "ZAČAS",
  "ZAČET",
  "ZAČIN",
  "ZAŠTO",
  "ZBITI",
  "ZBJEG",
  "ZBRDA",
  "ZBRKA",
  "ZBROJ",
  "ZDOLA",
  "ZDRAV",
  "ZDRUG",
  "ZEBRA",
  "ZECOM",
  "ZEFIR",
  "ZELEN",
  "ZELJE",
  "ZELOT",
  "ZEMNI",
  "ZEMUN",
  "ZENIT",
  "ZENON",
  "ZEČIĆ",
  "ZEČJI",
  "ZGLOB",
  "ZGODA",
  "ZGURA",
  "ZIDAR",
  "ZIDIĆ",
  "ZIDNI",
  "ZIJAN",
  "ZIJEV",
  "ZIMUS",
  "ZIPKA",
  "ZIĐEM",
  "ZLATA",
  "ZLATO",
  "ZLOBA",
  "ZLOĆA",
  "ZMIJA",
  "ZNATI",
  "ZNAČI",
  "ZOBEN",
  "ZOBUN",
  "ZOLJA",
  "ZOMBI",
  "ZORAN",
  "ZORKA",
  "ZORNI",
  "ZRAKA",
  "ZRELI",
  "ZRITI",
  "ZRNAT",
  "ZRNCE",
  "ZRNJE",
  "ZUBAC",
  "ZUBAR",
  "ZUBAT",
  "ZUBIĆ",
  "ZUBNI",
  "ZUJAV",
  "ZULUF",
  "ZULUM",
  "ZVATI",
  "ZVEKA",
  "ZVONO",
  "ĆELAV",
  "ĆEVAP",
  "ĆILIM",
  "ĆOPAV",
  "ĆORAK",
  "ĆORAV",
  "ĆOSAV",
  "ĆOŠAK",
  "ĆUMEZ",
  "ĆUŠKA",
  "ČABAR",
  "ČADOR",
  "ČAJNI",
  "ČAKIR",
  "ČAKRA",
  "ČALMA",
  "ČAMAC",
  "ČANAK",
  "ČARDA",
  "ČARKA",
  "ČASAK",
  "ČASNI",
  "ČAVAO",
  "ČAVKA",
  "ČAZMA",
  "ČAĐAV",
  "ČAŠKA",
  "ČEDNI",
  "ČEKAČ",
  "ČEKIĆ",
  "ČELIK",
  "ČELNI",
  "ČEMER",
  "ČEONI",
  "ČEPIĆ",
  "ČEREK",
  "ČERGA",
  "ČESMA",
  "ČETIN",
  "ČETKA",
  "ČETNI",
  "ČEČEN",
  "ČEŠER",
  "ČEŠKI",
  "ČEŠĆI",
  "ČIBUK",
  "ČIFUT",
  "ČIGRA",
  "ČINEL",
  "ČIODA",
  "ČIOVO",
  "ČIPKA",
  "ČIRIĆ",
  "ČITAV",
  "ČITAČ",
  "ČITKI",
  "ČIZMA",
  "ČIČAK",
  "ČIŠĆI",
  "ČOBAN",
  "ČOKOT",
  "ČOPER",
  "ČOPOR",
  "ČORBA",
  "ČUDAK",
  "ČUDNI",
  "ČUJNI",
  "ČULNI",
  "ČUNAK",
  "ČUPAV",
  "ČUVAN",
  "ČUVAR",
  "ČUVEN",
  "ČVRST",
  "ĐAKON",
  "ĐAVAO",
  "ĐAČIĆ",
  "ĐUBAR",
  "ĐUBRE",
  "ĐURIN",
  "ĐURĐA",
  "ŠAJKA",
  "ŠAKAL",
  "ŠAKAČ",
  "ŠALJU",
  "ŠAMAN",
  "ŠAMAR",
  "ŠAMOT",
  "ŠANAC",
  "ŠANSA",
  "ŠAPAT",
  "ŠAPKA",
  "ŠAPTA",
  "ŠARAC",
  "ŠARAF",
  "ŠARAN",
  "ŠAREN",
  "ŠARKA",
  "ŠAROV",
  "ŠARUN",
  "ŠARŽA",
  "ŠATOR",
  "ŠAŠAV",
  "ŠEGRT",
  "ŠEKEL",
  "ŠENOA",
  "ŠEPAV",
  "ŠERET",
  "ŠERIF",
  "ŠERPA",
  "ŠETAČ",
  "ŠETNI",
  "ŠEVAR",
  "ŠEĆER",
  "ŠEŠIR",
  "ŠIBER",
  "ŠIFON",
  "ŠIFRA",
  "ŠIJIT",
  "ŠIKAN",
  "ŠIMIN",
  "ŠINJA",
  "ŠIPAK",
  "ŠIPKA",
  "ŠIREN",
  "ŠIRIT",
  "ŠIROK",
  "ŠIŠAČ",
  "ŠIŠKA",
  "ŠKAMP",
  "ŠKARE",
  "ŠKART",
  "ŠKIJA",
  "ŠKODA",
  "ŠKOLA",
  "ŠKOLJ",
  "ŠKRGA",
  "ŠKRIP",
  "ŠKROB",
  "ŠKUDA",
  "ŠKUNA",
  "ŠKURA",
  "ŠKVER",
  "ŠLAPA",
  "ŠLJAM",
  "ŠLJEM",
  "ŠNALA",
  "ŠNITA",
  "ŠOFER",
  "ŠOGOR",
  "ŠOGUN",
  "ŠOJKA",
  "ŠOKAC",
  "ŠOLJA",
  "ŠOLTA",
  "ŠPAGA",
  "ŠPENA",
  "ŠPICA",
  "ŠPIGL",
  "ŠPIRO",
  "ŠPORT",
  "ŠTAKA",
  "ŠTALA",
  "ŠTAND",
  "ŠTEKA",
  "ŠTENE",
  "ŠTETA",
  "ŠTIFT",
  "ŠTIVO",
  "ŠTONO",
  "ŠTRIK",
  "ŠTUKA",
  "ŠTULA",
  "ŠUGAV",
  "ŠUICA",
  "ŠUMAR",
  "ŠUMNI",
  "ŠUMOR",
  "ŠUNKA",
  "ŠUPAK",
  "ŠUTKE",
  "ŠUŠKA",
  "ŠVABA",
  "ŠVERC",
  "ŠVORC",
  "ŽABAC",
  "ŽABAR",
  "ŽAGOR",
  "ŽAKET",
  "ŽALAC",
  "ŽALBA",
  "ŽAMOR",
  "ŽANJE",
  "ŽANJI",
  "ŽANJU",
  "ŽAOKA",
  "ŽARAČ",
  "ŽAREN",
  "ŽARKI",
  "ŽARNI",
  "ŽBICA",
  "ŽBUKA",
  "ŽDRAL",
  "ŽEDNI",
  "ŽELJA",
  "ŽENIK",
  "ŽENKA",
  "ŽEPČE",
  "ŽETON",
  "ŽETVA",
  "ŽEZLO",
  "ŽEŠĆI",
  "ŽEŽEN",
  "ŽICAR",
  "ŽIDAK",
  "ŽIDOV",
  "ŽILAV",
  "ŽILET",
  "ŽILJE",
  "ŽILNI",
  "ŽITAK",
  "ŽITKI",
  "ŽITNI",
  "ŽIVAC",
  "ŽIVAD",
  "ŽIVEŽ",
  "ŽIVOT",
  "ŽIČAN",
  "ŽIČNI",
  "ŽIŽAK",
  "ŽLICA",
  "ŽMINJ",
  "ŽNORA",
  "ŽOHAR",
  "ŽRTVA",
  "ŽUBOR",
  "ŽUDNI",
  "ŽUPAN",
  "ŽUPNI",
  "ŽURBA",
  "ŽUREN",
  "ŽURNI",
  "ŽUČNI",
  "ŽUĐEN",
  "ŽVALA"
];
